const LISTENER = {
  ready: false,
  CALLBACKS: []
};

export default class UrlHash {
  static onChange(callback) {
    if (!LISTENER.ready) {
      LISTENER.ready = true;
      window.UrlHash = UrlHash;
      window.addEventListener('hashchange', () => {
        LISTENER.CALLBACKS.forEach((callback) => {
          callback.call();
        });
      });
    }

    LISTENER.CALLBACKS.push(callback);
  }

  static clean(hash) {
    return (hash !== undefined && hash.toString().replace(/^#[!]?/, '')) || '';
  }

  static get() {
    return UrlHash.clean(window.location.hash);
  }

  static set(hash) {
    window.location.hash = '#!' + UrlHash.clean(hash);
    return window.location.hash;
  }

  static toArray() {
    return UrlHash.get().split('&');
  }

  static fromArray(hashArray) {
    return (
      hashArray &&
      Array.isArray(hashArray) &&
      hashArray
        .map((item) => {
          if (Array.isArray(item)) {
            return UrlHash.fromArray(item);
          } else if (typeof item === 'object') {
            return UrlHash.fromObject(item);
          } else {
            return item;
          }
        })
        .join('&')
    );
  }

  static fromObject(data) {
    return (
      data &&
      Object.keys(data)
        .map((key) => {
          if (data[key] !== undefined) {
            if (typeof data[key] === 'object') {
              return Object.keys(data[key])
                .map((index) => {
                  return `${encodeURIComponent(key)}=${encodeURIComponent(data[key][index])}`;
                })
                .join('&');
            } else {
              return `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`;
            }
          } else {
            return encodeURIComponent(key);
          }
        })
        .join('&')
    );
  }

  static has(hash) {
    const cleanHash = UrlHash.clean(hash);
    return UrlHash.toArray().indexOf(cleanHash) !== -1;
  }

  static add(hash) {
    const cleanHash = UrlHash.clean(hash);
    let hashArray = UrlHash.toArray();
    if (hashArray.indexOf(cleanHash) === -1) {
      hashArray.push(cleanHash);
      UrlHash.set(UrlHash.fromArray(hashArray));
    }
  }

  static remove(hash) {
    const cleanHash = UrlHash.clean(hash);
    let hashArray = UrlHash.toArray();
    const hashIndex = hashArray.indexOf(cleanHash);
    if (hashIndex !== -1) {
      hashArray.splice(hashIndex, 1);
      UrlHash.set(UrlHash.fromArray(hashArray));
    }
  }

  static clear() {
    UrlHash.set('');
  }
}
